// extracted by mini-css-extract-plugin
module.exports = {"snippetWrapper":"_0e46d4","reviewsSection":"_259d9a","reviewSnippetsGeneral":"_ebe3c9","titleContainer":"_a298ca"};